import {styled} from "@mui/material/styles";
import Link, {LinkProps} from "@mui/material/Link";
import Button, {ButtonProps} from "@mui/material/Button";
import Toolbar, {ToolbarProps} from "@mui/material/Toolbar";
import InputBase from '@mui/material/InputBase';


export const DaToolbar = styled(Toolbar)<ToolbarProps>(({ theme }) => ({
    backgroundColor: theme.daPalette.greyBlue.main,
    minHeight: "56px",
    paddingTop: 8,
    paddingBottom: 8,
    marginBottom: 8, // Restore original margin for desktop look
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: 'none',
    border: 'none',
}));

// Remove border-radius and margin from the table header to ensure flush join
export const DataGridHeaderOverride = styled('div')(({ theme }) => ({
    '& .MuiDataGrid-columnHeaders': {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        marginTop: 0,
    },
}));
export const DaToolbarLink = styled(Link)<LinkProps>(({ theme }) => ({
    color: theme.daPalette.grey.contrastText,
    backgroundColor: theme.daPalette.grey.main,     // Main: #dcddde, Light: #e3e3e4, Dark: #c6c6c7
    "&:hover": {
        backgroundColor: theme.daPalette.grey.dark,
    },
    paddingTop: theme.spacing(.75),
    paddingRight: theme.spacing(1.5),
    paddingBottom: theme.spacing(.75),
    paddingLeft: theme.spacing(1.5),
    lineHeight: theme.spacing(3.5),
    borderRadius: theme.shape.borderRadius,
    marginRight: 4,
    textDecoration: "none",
    cursor: "pointer",
}));

export const DaToolbarButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: theme.daPalette.grey.contrastText,
    backgroundColor: theme.daPalette.grey.light,     // Main: #dcddde, Light: #e3e3e4, Dark: #c6c6c7
    "&:hover": {
        backgroundColor: theme.daPalette.grey.main,
    },
    paddingTop: theme.spacing(.75),
    paddingBottom: theme.spacing(.75),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
    lineHeight: theme.spacing(2.5),
    marginRight: 5,
    textTransform: "none",
    cursor: "pointer",
}));

export const Search = styled('div')(({ theme }) => ({
    // position: 'relative',
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    color: theme.daPalette.grey.contrastText,
    backgroundColor: theme.daPalette.grey.light,     // Main: #dcddde, Light: #e3e3e4, Dark: #c6c6c7
    "&:hover, &:focus-within": {
        backgroundColor: "#ffffff",
    },

    marginLeft: 0,

    width: '100%',
    [theme.breakpoints.up('xs')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
      padding: theme.spacing(.5, 1, .5, 0),
      marginLeft: theme.spacing(1),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('xs')]: {
          width: '12ch',
          '&:focus': {
              width: '28ch',
          },
      },
      [theme.breakpoints.up('sm')]: {
          '&:focus': {
              width: '36ch',
          },
      },
  },
}));
